export default __webpack_public_path__ + "static/projector_w.4a4eda5a6639217de4e2730b3072750c.png";